const WIDGETS_KEYS = {
  WIDGETS: () => ['widgets'],
  WIDGETS_PAGINATED: (params = {}) => [...WIDGETS_KEYS.WIDGETS(), 'paginated', params],
  WIDGET_DETAIL: (uid) => [...WIDGETS_KEYS.WIDGETS(), 'detail', uid],
  WIDGET_PUBLIC: (uid) => [...WIDGETS_KEYS.WIDGETS(), 'detail', uid, 'public'],
};

export default WIDGETS_KEYS;
